import { render, staticRenderFns } from "./FailedDeliveryConfigurationModal.vue?vue&type=template&id=7a57b07a&scoped=true&"
import script from "./FailedDeliveryConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./FailedDeliveryConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./FailedDeliveryConfigurationModal.vue?vue&type=style&index=0&id=7a57b07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a57b07a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a57b07a')) {
      api.createRecord('7a57b07a', component.options)
    } else {
      api.reload('7a57b07a', component.options)
    }
    module.hot.accept("./FailedDeliveryConfigurationModal.vue?vue&type=template&id=7a57b07a&scoped=true&", function () {
      api.rerender('7a57b07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/FailedDeliveryConfigurationModal.vue"
export default component.exports